export default __webpack_public_path__ + "static/media/ic-call-off-order-menu.051d7bda.svg";